import angular from 'angular';

module.exports = angular.module('common.directives.decimal-to-percent', [])
.directive('type', function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      if (attrs.type !== 'decimal-to-percent' || !ngModel) return;

      //  number -> decimal (3 -> .03)
      ngModel.$parsers.push(function(value) {
        if (!value) return null;
        return value / 100.0;
      });

      // decimal -> number (.03 -> 3)
      ngModel.$formatters.push(function(value) {
        if (!value && value !== 0) return null;
        return (value * 100.0).toFixed(2);
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/decimal-to-percent.js
 **/